import {
  Box,
  Heading,
  Center,
  useColorModeValue,
  Text,
  useToast,
} from "@chakra-ui/react";
import * as React from "react";
import { Link } from "react-router-dom";
import { Card } from "../components/Login/Card";
import { Logo } from "../components/shared/Logo";
import { ResetForm } from "../components/Reset/ResetForm";
import { Link as ChakraLink } from "../components/Login/Link";
import { useAuth } from "../../../contexts/Auth";
const Reset = () => {
  const { resetPassword } = useAuth() as {
    resetPassword: (email: string) => Promise<void>;
  };
  const toast = useToast();

  const onSubmit = (email: string) => {
    resetPassword(email).then(() => {
      toast({
        title: "Reset instructions sent",
        description:
          "If your email address exists, an email has been sent to it.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    });
  };

  return (
    <Box
      bg={useColorModeValue("gray.50", "inherit")}
      minH="100vh"
      py="12"
      px={{ base: "4", lg: "8" }}
    >
      <Box maxW="md" mx="auto">
        <Center mx="auto" h="8" mb={{ base: "10", md: "20" }}>
          <Logo />
        </Center>
        <Heading textAlign="center" size="xl" fontWeight="extrabold">
          Forgot password?
        </Heading>
        <Text mt="4" mb="8" align="center" maxW="md" fontWeight="medium">
          <Text as="span">
            Enter the email address associated with your account, and we'll send
            you a link to reset your password.
          </Text>
          <Link to="/login">
            <ChakraLink>Back to sign in</ChakraLink>
          </Link>
        </Text>
        <Card>
          <ResetForm onSubmit={onSubmit} />
        </Card>
      </Box>
    </Box>
  );
};

export default Reset;
